import React,{useState} from 'react'


const TextForm = (props) => {
  const [text,setText]=useState('Enter text here')
  const handleUpClick=()=>{
    //console.log("UpperCase was clicked  " + text);
    let newText=text.toUpperCase();
    setText(newText);
  }
  
  const handleOnChange=(event)=>{
   // console.log("OnChange");
    setText(event.target.value)
  }
  const handleLowClick=()=>{
    let newText=text.toLowerCase();
    setText(newText);
  }
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
  };
  return (
    <>
    <div>
  <div className="mx-3 ">
  <h1>{props.heading}</h1>
    <label htmlFor="myBox" className="form-label">Example Text</label>
    <textarea className="form-control" value={text} onChange={handleOnChange} id='myBox' rows="8" />
  </div>
  <button  className="btn btn-primary mx-2" onClick={handleUpClick}>Convert to Uppercase </button>
  <button  className="btn btn-primary mx-2" onClick={handleLowClick}>Convert to Lowercase </button>
  <button className="btn btn-primary mx-2" onClick={handleCopy}>
      {isCopied ? "Copied!" : "Copy to clipboard"}
    </button>
</div>
<div className='container my-3'>
<h3>Your Text Summary</h3>
<p>{text.split(" ").length} words and {text.length} characters</p>
<p>{0.008*text.split(" ").length} Minutes Read</p>
<h3>Preview</h3>
<p>{text}</p>


</div>

</>
  )
}

export default TextForm